import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const selectPartnerState = (state: RootState) => state.partner;

export const selectTeamsForTeamSelector = createSelector(
    [selectPartnerState],
    (partner) => partner.teamsForTeamSelector,
);

export const selectSelectedTeamsId = createSelector([selectPartnerState], (partner) => partner.selectedTeamsId);

export const selectPartnerData = createSelector([selectPartnerState], (partner) => partner.partnerData);
